import React from "react";
import PropTypes from "prop-types";

import { Modal, Content, ContainerTable, ContainField } from "./styles";

const ModalSupervision = ({ modalVisible, setModalVisible, info }) => {
  return (
    modalVisible && (
      <Modal onClick={() => setModalVisible(false)}>
        <Content onClick={(event) => event.stopPropagation()}>
          <ContainerTable>
            <tr>
              <ContainField>NOMBRE</ContainField>
              <ContainField>APELLIDO</ContainField>
              <ContainField>TIPO DE DOCUMENTO</ContainField>
              <ContainField>NUMERO DE DOCUMENTO</ContainField>
              <ContainField>NUMERO CELULAR</ContainField>
            </tr>
            <tr>
              <ContainField>{info?.firstName}</ContainField>
              <ContainField>{info?.lastName}</ContainField>
              <ContainField>{info?.documentType.name}</ContainField>
              <ContainField>{info?.documentNumber}</ContainField>
              <ContainField>{info?.phoneNumber}</ContainField>
            </tr>
          </ContainerTable>
        </Content>
      </Modal>
    )
  );
};

ModalSupervision.propTypes = {
  modalVisible: PropTypes.bool,
  setModalVisible: PropTypes.func,
  info: PropTypes.object,
};

export default ModalSupervision;
